import { createSelector } from '@reduxjs/toolkit'
import { RootState } from "@/store/store";

const rootSelector = (state: RootState) => state.specialists;

export const specialistsSelector = rootSelector;
export const specialistsUsersSelector = createSelector([rootSelector], ({ users }) => users);
export const specialistsSelectedSelector = createSelector([rootSelector], ({ selected }) => selected);
